module.exports = __webpack_public_path__ + "img/中国报道新闻网_03.64fac332.jpg";